import React from "react";
import { Layout, Menu } from "antd";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";

import { IconLight } from "../";

const Header = ({ email }) => {
  return (
    <Layout.Header
      style={{
        // position: "fixed",
        width: "100%",
        zIndex: "3",
        height: "56px",
        backgroundColor: "#111"
      }}
    >
      <div
        style={{
          display: "inline-block",
          float: "left",
          width: "300px",
          marginLeft: "-30px",
          marginTop: "-5px"
        }}
      >
        <NavLink to="/">
          <span
            style={{
              fontSize: "large",
              color: "white",
              // margin: "10px 0 0 0",
              display: "inline-block"
            }}
          >
            <img
              style={{
                display: "inline-block",
                maxWidth: "100px",
                marginRight: "16px"
              }}
              src="/images/pdView-Logo-colour-Land-white-markup.png"
              alt="pdView"
            />
            Internal Apps
          </span>
        </NavLink>
      </div>
      <Menu
        theme="dark"
        mode="horizontal"
        style={{
          lineHeight: "56px",
          display: "inline-block",
          float: "right",
          backgroundColor: "#111"
        }}
      >
        <Menu.SubMenu
          title={
            <span>
              <IconLight icon={"user"} /> {email}
            </span>
          }
        >
          <Menu.Item key="logout">
            <NavLink to="/logout">
              <IconLight icon={"sign-out"} /> Logout
            </NavLink>
          </Menu.Item>
        </Menu.SubMenu>
      </Menu>
    </Layout.Header>
  );
};

Header.propTypes = {
  email: PropTypes.string
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/Header.jsx